<template>
  <div class="page-audit">
    <crm-panel :title="'客户审核'">
      <!-- 搜索条 -->
      <div class="form mt20">
        <div>
          <el-form
            ref="form"
            :inline="true"
            :model="searchForm"
            label-width="20px"
          >
            <el-form-item label="">
              <el-select
                clearable
                v-model="searchForm.categoryUid"
                placeholder="客户类型"
              >
                <el-option
                  :key="item.uid"
                  v-for="item in clientType"
                  :label="item.name"
                  :value="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-select
                clearable
                v-model="searchForm.auditStatus"
                placeholder="审核状态"
              >
                <we-audit-status-options v-once />
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-input
                placeholder="根据姓名查询"
                v-model="searchName"
                class="input-with-select"
              >
                <el-select v-model="searchForm.nameType" slot="prepend">
                  <we-audit-nametype-options v-once />
                </el-select>
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search"
                  @click="handleSearch"
                  style="cursor: pointer"
                ></i>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- <div class="table-wrap"> -->
      <!-- 客户审核列表 -->
      <el-table
        :data="clientAuditData.results"
        v-loading="tableLoading"
        height="100%"
        style="width: 100%"
      >
        <el-table-column label="客户名称" align="center">
          <template slot-scope="{ row }">
            {{ [row.name, row.depaName].filter(Boolean).join('-') }}
          </template>
        </el-table-column>
        <el-table-column prop="categoryName" label="客户类型" align="center">
        </el-table-column>
        <!-- width="200" -->
        <el-table-column label="地区" align="center">
          <template slot-scope="{ row }">
            {{
              [row.province, row.city, row.district].filter(Boolean).join('/')
            }}
          </template>
        </el-table-column>
        <!-- width="140" -->
        <el-table-column prop="salesmanName" label="业务员" align="center">
        </el-table-column>
        <!-- width="140" -->
        <el-table-column prop="principalName" label="创建人" align="center">
        </el-table-column>
        <el-table-column label="提交日期" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.gmtCreated | formatTimeShow }}</span>
          </template>
        </el-table-column>
        <!-- width="140" -->
        <el-table-column prop="auditStatus" label="审核状态" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.auditStatus | auditStatusMap }}</span>
          </template>
        </el-table-column>
        <!-- width="140" -->
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="
                scope.row.auditStatus === 0 &&
                  ((auth.CustomerApprovePass &&
                    auth.CustomerApprovePass.toggleStatus) ||
                    (auth.customerApproveUnPass &&
                      auth.customerApproveUnPass.toggleStatus))
              "
              @click="goOpration(scope, true)"
              type="text"
              size="small"
            >
              审核
            </el-button>
            <el-button
              v-if="
                scope.row.auditStatus !== 0 &&
                  auth.customerApproveDetail &&
                  auth.customerApproveDetail.toggleStatus
              "
              @click="goOpration(scope, false)"
              type="text"
              size="small"
            >
              查看
            </el-button>
            <el-button
              v-if="
                auth.customerApproveDelete &&
                  auth.customerApproveDelete.toggleStatus
              "
              @click="handleDelete(scope)"
              type="text"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 客户审核列表分页 -->
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchForm.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="searchForm.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="clientAuditData.totalCount"
        >
        </el-pagination>
      </div>
      <!-- </div> -->
    </crm-panel>

    <check-detail
      v-if="detail.visible"
      :detail="detail"
      @close="handleDetailClose"
    >
    </check-detail>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { formatTime, formatTimeShow } from '@/scripts/utils';
import crmPanel from '@/components/base/crmPanel';
import WeSearchInputTypeOptions from '~component/business/custom/search-input-type-options';
import WeAuditStatusOptions from '~component/business/audit/audit-status-options';
import WeAuditNametypeOptions from '~component/business/audit/audit-nametype-options';
import CheckDetail from '~component/business/audit/checkDetail';

export default {
  components: {
    crmPanel,
    WeSearchInputTypeOptions,
    WeAuditNametypeOptions,
    WeAuditStatusOptions,
    CheckDetail,
  },
  filters: {
    formatTime,
    formatTimeShow,
    auditStatusMap(val) {
      let result = '';
      switch (val) {
        case 0:
          result = '待审核';
          break;
        case 2:
          result = '通过';
          break;
        case 3:
          result = '驳回';
          break;
        default:
          break;
      }
      return result;
    },
  },
  data() {
    return {
      tableLoading: false,
      // 客户名称表单，提交时会根据表单下方的单选按钮传给后台不同的key，所以单独拎出来
      searchName: '',
      // 搜索表单
      searchForm: {
        categoryUid: '',
        auditStatus: 0,
        pageSize: 10,
        pageNumber: 1,
        nameType: 1,
      },
      proAuditList: [],
      detail: {
        visible: false,
        uid: null,
        type: null,
        isAudit: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      auth: 'authority/auth',
      clientType: 'audit/clientType',
      clientAuditData: 'audit/clientAuditData',
    }),
  },
  watch: {
    'searchForm.categoryUid': {
      handler: 'handleSearch',
    },
    'searchForm.auditStatus': {
      handler: 'handleSearch',
    },
  },
  created() {
    this.getClientType({
      pageNumber: '1',
      pageSize: '50',
      code: 'category_customer',
    });
    this.handleSearch();
  },
  methods: {
    ...mapActions({
      getCrmAuth: 'common/getCrmAuth',
      getClientType: 'audit/getClientType',
      getClientAuditList: 'audit/getClientAuditList',
      deleteHandleAudit: 'audit/deleteHandleAudit',
    }),
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.getClientData();
    },
    getClientData() {
      this.tableLoading = true;

      this.searchForm.name = null;
      this.searchForm.customerNo = null;
      this.searchForm.salesmanName = null;
      this.searchForm.principalName = null;
      if (this.searchForm.nameType === 1) {
        this.searchForm.name = this.searchName;
      } else if (this.searchForm.nameType === 2) {
        this.searchForm.customerNo = this.searchName;
      } else if (this.searchForm.nameType === 3) {
        this.searchForm.salesmanName = this.searchName;
      } else if (this.searchForm.nameType === 4) {
        this.searchForm.principalName = this.searchName;
      }

      this.getClientAuditList(this.searchForm).finally(() => {
        this.tableLoading = false;
      });
    },
    goOpration(scope, isAudit) {
      this.detail = {
        visible: true,
        uid: scope.row.uid,
        type: scope.row.type,
        isAudit,
      };
    },
    // 删除
    handleDelete(scope) {
      this.$confirm('是否确定删除客户？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const params = {
            uid: [scope.row.uid],
          };
          this.deleteHandleAudit(params).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.handleSearch();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    handleDetailClose() {
      this.detail.visible = false;
      this.handleSearch();
    },
    handleCurrentChange(val) {
      this.searchForm.pageNumber = val;
      this.getClientData();
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.searchForm.pageNumber = 1;
      this.getClientData();
    },
  },
};
</script>

<style lang="less">
@import '~@/styles/var.less';

.page-audit {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
}
</style>
